import React from 'react'
import { Link } from "react-router";
import {
  FiPlus,
  FiSearch,
  FiEdit2,
  FiTrash2,
} from "react-icons/fi";
import { useSelector } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import { useDispatch } from "react-redux";
function Reminderlist() {
  const dispatch = useDispatch();
  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Reminder List</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Reminder List</span>
          </nav>
        </div>

        <div className="page-title fw-semibold fs-18 mb-0">
          {/* <Link to="/reminder" className="add-btn">
            <FiPlus className="me-2" />
            Add Reminder
          </Link> */}

          <button
            className="lead-btn btn-import"
            onClick={() =>
              dispatch(
                openModal({
                  type: "add-reminder",
                  title: "Add Reminder",
                  // data: {
                  //     onSuccess: refreshLeads,
                  // },
                })
              )
            }
          >
            Add Reminder
          </button>
        </div>
      </div>

      <div className="main_page">
        <div className="card">
          <div className="card-body">

            {/* Search */}
            <div className="row mb-3">
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control custumform"
                  placeholder="Search Reminder..."
                />
              </div>

              <div className="col-md-3">
                <select className="form-control custumform">
                  <option>All Priority</option>
                  <option>High</option>
                  <option>Medium</option>
                  <option>Low</option>
                </select>
              </div>

              <div className="col-md-3">
                <select className="form-control custumform">
                  <option>All Status</option>
                  <option>Pending</option>
                  <option>Completed</option>
                </select>
              </div>

              <div className="col-md-2">
                <button className="total_btn lead-btn btn-import w-100">
                  <FiSearch className="me-2" />
                  Search
                </button>
              </div>
            </div>

            {/* Table */}
            <div className="st-wrapper-card text-center">
              <div className="st-table-responsive">
                <table className="table st-custom-table align-middle mb-0">

                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>#</th>
                      <th>Title</th>
                      <th>Type</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Priority</th>
                      <th>Assigned To</th>
                      <th>Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* Row 1 */}
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td>1</td>
                      <td>Client Meeting</td>
                      <td>Meeting</td>
                      <td>25-07-2026</td>
                      <td>10:30 AM</td>
                      <td>
                        <span className="badge bg-danger">High</span>
                      </td>
                      <td>Rohit</td>
                      <td>
                        <span className="badge bg-warning text-dark">Pending</span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          <button
                            type="button"
                            className="st-action-btn st-view-btn"
                            title="Edit"
                          >
                            <FiEdit2 />
                          </button>

                          <button
                            type="button"
                            className="st-action-btn st-delete-btn"
                            title="Delete"
                          >
                            <FiTrash2 />
                          </button>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td>2</td>
                      <td>Project Follow-up</td>
                      <td>Call</td>
                      <td>26-07-2026</td>
                      <td>03:00 PM</td>
                      <td>
                        <span className="badge bg-success">Low</span>
                      </td>
                      <td>Deepak</td>
                      <td>
                        <span className="badge bg-success">Completed</span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          <button
                            type="button"
                            className="st-action-btn st-view-btn"
                            title="Edit"
                          >
                            <FiEdit2 />
                          </button>

                          <button
                            type="button"
                            className="st-action-btn st-delete-btn"
                            title="Delete"
                          >
                            <FiTrash2 />
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td>3</td>
                      <td>Employee Birthday</td>
                      <td>Birthday</td>
                      <td>28-07-2026</td>
                      <td>09:00 AM</td>
                      <td>
                        <span className="badge bg-info text-dark">Medium</span>
                      </td>
                      <td>Admin</td>
                      <td>
                        <span className="badge bg-warning text-dark">Pending</span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          <button
                            type="button"
                            className="st-action-btn st-view-btn"
                            title="Edit"
                          >
                            <FiEdit2 />
                          </button>

                          <button
                            type="button"
                            className="st-action-btn st-delete-btn"
                            title="Delete"
                          >
                            <FiTrash2 />
                          </button>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td>4</td>
                      <td>Monthly Report</td>
                      <td>Task</td>
                      <td>30-07-2026</td>
                      <td>05:00 PM</td>
                      <td>
                        <span className="badge bg-primary">Medium</span>
                      </td>
                      <td>Admin</td>
                      <td>
                        <span className="badge bg-success">Completed</span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          <button
                            type="button"
                            className="st-action-btn st-view-btn"
                            title="Edit"
                          >
                            <FiEdit2 />
                          </button>

                          <button
                            type="button"
                            className="st-action-btn st-delete-btn"
                            title="Delete"
                          >
                            <FiTrash2 />
                          </button>
                        </div>
                      </td>
                    </tr>

                    {/* Row 5 */}
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td>5</td>
                      <td>Client Payment Reminder</td>
                      <td>Call</td>
                      <td>01-08-2026</td>
                      <td>11:00 AM</td>
                      <td>
                        <span className="badge bg-danger">High</span>
                      </td>
                      <td>Rohit</td>
                      <td>
                        <span className="badge bg-warning text-dark">Pending</span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          <button
                            type="button"
                            className="st-action-btn st-view-btn"
                            title="Edit"
                          >
                            <FiEdit2 />
                          </button>

                          <button
                            type="button"
                            className="st-action-btn st-delete-btn"
                            title="Delete"
                          >
                            <FiTrash2 />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Reminderlist
